module.exports = "/static/fonts/OpenSans-Regular.woff";